import { render } from "./ForgotPassword.vue?vue&type=template&id=05b99a13&scoped=true&lang=pug"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"

import "./ForgotPassword.vue?vue&type=style&index=0&id=05b99a13&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-05b99a13"

export default script